/* global axios */
import ApiClient from './ApiClient';

const authHeaders = (token, jwt) => ({
  'X-Ardhisasa-Token': token,
  'X-Ardhisasa-Jwt': jwt,
});

class ArdhisasaAgents extends ApiClient {
  constructor() {
    super('ardhisasa_agents', { accountScoped: true });
  }

  createWithArdhisasa(payload, token, jwt) {
    return axios.post(this.url, payload, { headers: authHeaders(token, jwt) });
  }

  reconcile(payload, token, jwt) {
    return axios.post(`${this.url}/reconcile`, payload, {
      headers: authHeaders(token, jwt),
    });
  }
}

export default new ArdhisasaAgents();
